import { queryKeys } from '../../shared';
import { useSave } from '../../shared/hooks/new-base.hook';
import { useList, UseListParams } from '../../shared/hooks/new-read-only.hook';
import { cardSetClient } from '../clients/card-set.client';
import { ICardSet } from '../models';

const client = cardSetClient;
const listKey = queryKeys.CARD_SETS;
const itemKey = queryKeys.CARD_SET;

export function useCardSetList(...args: UseListParams<ICardSet>) {
    return useList(client, listKey, args);
}

export function useSaveCardSet() {
    return useSave(client, listKey, itemKey);
}
